import React from 'react';
import { getStatusColor } from './StatusBadge';

// Renders a compact breakdown of counts per status, e.g. "3 initiated, 1 closed"
const StatusCounts = ({ stats, emptyText = 'None' }) => {
  const total = stats?.total || 0;
  const byStatus = stats?.by_status || {};
  const entries = Object.entries(byStatus).filter(([, count]) => count > 0);

  if (total === 0 || entries.length === 0) {
    return <span className="text-muted small">{emptyText}</span>;
  }

  return (
    <div className="d-flex gap-1 flex-wrap align-items-center">
      {entries.map(([status, count]) => (
        <span
          key={status}
          className={`badge bg-${getStatusColor(status)}`}
          style={{ fontSize: '11px' }}
          title={`${count} ${status.replace(/_/g, ' ')}`}
        >
          {status.replace(/_/g, ' ')}: {count}
        </span>
      ))}
    </div>
  );
};

export default StatusCounts;
